import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import MediumForm from '../containers/MediumFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class MediumAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `MediumAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('media_route_add')} />
          <MediumForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default MediumAddScreen;

Logger.log('silly', `MediumAddScreen loaded.`);
